/*
 * CORPORATE GRIND - Revenue Optimization Suite
 * Version: 2.1.0 - Urgency DISABLED for POD
 * Features: BNPL Messaging, Bundle Discounts, Sticky ATC, Urgency/Scarcity, Loyalty Teaser
 */

(function() {
  "use strict";
  
  console.log("[CG Revenue] v1.0.0 loaded");
  
  // ============================================================
  // P1 #1: BNPL (Buy Now Pay Later) Messaging
  // ============================================================
  function addBNPLMessaging() {
    // Find product price elements
    var priceElements = document.querySelectorAll('.price__regular .price-item, .product__price, [class*="product-price"], .price');
    
    priceElements.forEach(function(priceEl) {
      // Skip if already has BNPL
      if (priceEl.parentNode.querySelector('.cg-bnpl-message')) return;
      
      // Extract price
      var priceText = priceEl.textContent || '';
      var priceMatch = priceText.match(/\$?([\d,]+\.?\d*)/);
      if (!priceMatch) return;
      
      var price = parseFloat(priceMatch[1].replace(',', ''));
      if (price < 20 || price > 5000) return; // Skip very low or high prices
      
      var installment = (price / 4).toFixed(2);
      
      // Create BNPL message
      var bnplDiv = document.createElement('div');
      bnplDiv.className = 'cg-bnpl-message';
      bnplDiv.innerHTML = '<span class="cg-bnpl-icon">💳</span> or 4 interest-free payments of <strong>$' + installment + '</strong> with <span class="cg-bnpl-provider">Shop Pay</span>';
      bnplDiv.style.cssText = 'font-size:13px;color:#6b7280;margin-top:8px;display:flex;align-items:center;gap:6px;flex-wrap:wrap;';
      
      // Style the provider name
      var providerSpan = bnplDiv.querySelector('.cg-bnpl-provider');
      if (providerSpan) {
        providerSpan.style.cssText = 'color:#5a31f4;font-weight:600;';
      }
      
      priceEl.parentNode.appendChild(bnplDiv);
    });
    
    console.log("[CG Revenue] BNPL messaging added");
  }
  
  // ============================================================
  // P1 #2: Bundle/Quantity Discount Banner
  // ============================================================
  function addBundleDiscountBanner() {
    // Only show on product pages
    if (!window.location.pathname.includes('/products/')) return;
    
    // Find the add to cart form
    var atcForm = document.querySelector('form[action*="/cart/add"], .product-form, [class*="product-form"]');
    if (!atcForm) return;
    
    // Skip if already has bundle banner
    if (document.querySelector('.cg-bundle-banner')) return;
    
    // Create bundle banner
    var bannerDiv = document.createElement('div');
    bannerDiv.className = 'cg-bundle-banner';
    bannerDiv.innerHTML = [
      '<div class="cg-bundle-header">',
      '  <span class="cg-bundle-icon">🎁</span>',
      '  <span class="cg-bundle-title">Bulk Discounts Available!</span>',
      '</div>',
      '<div class="cg-bundle-tiers">',
      '  <div class="cg-bundle-tier">',
      '    <span class="cg-tier-qty">2+</span>',
      '    <span class="cg-tier-discount">10% OFF</span>',
      '  </div>',
      '  <div class="cg-bundle-tier cg-tier-popular">',
      '    <span class="cg-tier-badge">BEST VALUE</span>',
      '    <span class="cg-tier-qty">3+</span>',
      '    <span class="cg-tier-discount">15% OFF</span>',
      '  </div>',
      '  <div class="cg-bundle-tier">',
      '    <span class="cg-tier-qty">5+</span>',
      '    <span class="cg-tier-discount">20% OFF</span>',
      '  </div>',
      '</div>',
      '<p class="cg-bundle-note">Mix & match any designs. Discount applies at checkout.</p>'
    ].join('');
    
    // Styles
    bannerDiv.style.cssText = 'background:linear-gradient(135deg,#fef3c7 0%,#fde68a 100%);border:2px solid #f59e0b;border-radius:12px;padding:10px;margin:12px 0;';
    
    // Insert before the form
    atcForm.parentNode.insertBefore(bannerDiv, atcForm);
    
    // Add tier styles
    addBundleStyles();
    
    console.log("[CG Revenue] Bundle discount banner added");
  }
  
  function addBundleStyles() {
    if (document.getElementById('cg-bundle-styles')) return;
    
    var style = document.createElement('style');
    style.id = 'cg-bundle-styles';
    style.textContent = [
      '.cg-bundle-header{display:flex;align-items:center;gap:6px;margin-bottom:8px;}',
      '.cg-bundle-icon{font-size:20px;}',
      '.cg-bundle-title{font-size:15px;font-weight:700;color:#92400e;}',
      '.cg-bundle-tiers{display:flex;gap:8px;justify-content:center;flex-wrap:wrap;}',
      '.cg-bundle-tier{background:#fff;border-radius:8px;padding:8px 12px;text-align:center;min-width:70px;border:2px solid #fcd34d;position:relative;}',
      '.cg-bundle-tier.cg-tier-popular{border-color:#f59e0b;box-shadow:0 4px 12px rgba(245,158,11,0.3);}',
      '.cg-tier-badge{position:absolute;top:-8px;left:50%;transform:translateX(-50%);background:#f59e0b;color:#fff;font-size:9px;font-weight:700;padding:2px 8px;border-radius:10px;white-space:nowrap;}',
      '.cg-tier-qty{display:block;font-size:18px;font-weight:800;color:#1e3a5f;}',
      '.cg-tier-discount{display:block;font-size:12px;font-weight:600;color:#059669;margin-top:2px;}',
      '.cg-bundle-note{font-size:10px;color:#78350f;text-align:center;margin:8px 0 0;}'
    ].join('');
    document.head.appendChild(style);
  }
  
  // ============================================================
  // P2 #1: Sticky Mobile Add-to-Cart
  // ============================================================
  function addStickyATC() {
    // Only on product pages and mobile
    if (!window.location.pathname.includes('/products/')) return;
    if (window.innerWidth > 768) return;
    
    // Find the original ATC button
    var originalATC = document.querySelector('button[name="add"], .product-form__submit, [class*="add-to-cart"], button[type="submit"][class*="btn"]');
    if (!originalATC) return;
    
    // Skip if already has sticky ATC
    if (document.querySelector('.cg-sticky-atc')) return;
    
    // Get product info
    var productTitle = document.querySelector('.product__title, h1[class*="product"], .product-single__title');
    var productPrice = document.querySelector('.price__regular .price-item, .product__price, [class*="product-price"]');
    
    var titleText = productTitle ? productTitle.textContent.trim().substring(0, 30) : 'This Item';
    var priceText = productPrice ? productPrice.textContent.trim() : '';
    
    // Create sticky bar
    var stickyBar = document.createElement('div');
    stickyBar.className = 'cg-sticky-atc';
    stickyBar.innerHTML = [
      '<div class="cg-sticky-info">',
      '  <span class="cg-sticky-title">' + titleText + (titleText.length >= 30 ? '...' : '') + '</span>',
      '  <span class="cg-sticky-price">' + priceText + '</span>',
      '</div>',
      '<button class="cg-sticky-btn">Add to Cart</button>'
    ].join('');
    
    document.body.appendChild(stickyBar);
    
    // Add styles
    addStickyATCStyles();
    
    // Handle click
    var stickyBtn = stickyBar.querySelector('.cg-sticky-btn');
    stickyBtn.addEventListener('click', function() {
      originalATC.click();
      stickyBtn.textContent = 'Added! ✓';
      stickyBtn.style.background = '#059669';
      setTimeout(function() {
        stickyBtn.textContent = 'Add to Cart';
        stickyBtn.style.background = '';
      }, 2000);
    });
    
    // Show/hide based on scroll position
    var lastScroll = 0;
    var atcRect = originalATC.getBoundingClientRect();
    
    function updateStickyVisibility() {
      var scrollY = window.scrollY;
      var atcTop = originalATC.getBoundingClientRect().top;
      
      // Show sticky when original ATC is out of view
      if (atcTop < -50 || atcTop > window.innerHeight) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
      
      lastScroll = scrollY;
    }
    
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    updateStickyVisibility();
    
    console.log("[CG Revenue] Sticky ATC added");
  }
  
  function addStickyATCStyles() {
    if (document.getElementById('cg-sticky-atc-styles')) return;
    
    var style = document.createElement('style');
    style.id = 'cg-sticky-atc-styles';
    style.textContent = [
      '.cg-sticky-atc{position:fixed;bottom:0;left:0;right:0;background:#fff;padding:12px 16px;display:flex;align-items:center;justify-content:space-between;gap:12px;box-shadow:0 -4px 20px rgba(0,0,0,0.15);z-index:9999;transform:translateY(100%);transition:transform 0.3s ease;border-top:1px solid #e5e7eb;}',
      '.cg-sticky-atc.visible{transform:translateY(0);}',
      '.cg-sticky-info{flex:1;min-width:0;}',
      '.cg-sticky-title{display:block;font-size:13px;font-weight:600;color:#1e3a5f;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
      '.cg-sticky-price{display:block;font-size:15px;font-weight:700;color:#059669;}',
      '.cg-sticky-btn{background:linear-gradient(135deg,#1e3a5f 0%,#2d4a6f 100%);color:#fff;border:none;padding:14px 24px;border-radius:8px;font-size:14px;font-weight:700;cursor:pointer;white-space:nowrap;transition:all 0.2s;}',
      '.cg-sticky-btn:active{transform:scale(0.98);}',
      '@media(min-width:769px){.cg-sticky-atc{display:none!important;}}'
    ].join('');
    document.head.appendChild(style);
  }
  
  // ============================================================
  // P2 #2: Urgency/Scarcity Elements
  // ============================================================
  function addUrgencyElements() {
    // COMPLETELY DISABLED v2.1 - POD business has no stock limitations
    // "Selling Fast" and stock urgency are misleading for print-on-demand
    console.log("[CG Revenue] Urgency elements DISABLED (POD business)");
    return; // Exit immediately - no urgency elements
  }
  
  function addUrgencyStyles() {
    if (document.getElementById('cg-urgency-styles')) return;
    
    var style = document.createElement('style');
    style.id = 'cg-urgency-styles';
    style.textContent = [
      '.cg-urgency-bar{display:flex;flex-direction:column;gap:8px;margin:16px 0;padding:12px 16px;background:#fef2f2;border-radius:10px;border-left:4px solid #ef4444;}',
      '.cg-urgency-item{display:flex;align-items:center;gap:8px;font-size:13px;color:#7f1d1d;}',
      '.cg-urgency-icon{font-size:16px;}',
      '.cg-urgency-text strong{font-weight:700;}',
      '@media(min-width:768px){.cg-urgency-bar{flex-direction:row;justify-content:space-between;}}'
    ].join('');
    document.head.appendChild(style);
  }
  
  // ============================================================
  // P3: Loyalty/Referral Program Teaser
  // ============================================================
  function addLoyaltyTeaser() {
    // Only on homepage or product pages
    var isHomepage = window.location.pathname === '/' || window.location.pathname === '';
    var isProductPage = window.location.pathname.includes('/products/');
    
    if (!isHomepage && !isProductPage) return;
    
    // Skip if already has loyalty teaser
    if (document.querySelector('.cg-loyalty-teaser')) return;
    
    // Find a good insertion point
    var insertPoint = isHomepage ? 
      document.querySelector('.shopify-section:nth-child(3), [class*="featured"], [class*="collection-list"]') :
      document.querySelector('.product-recommendations, [class*="related"], [class*="you-may-also"]');
    
    if (!insertPoint && isProductPage) {
      // Try to find after product info
      insertPoint = document.querySelector('.product__info-container, .product-single__meta, [class*="product-info"]');
    }
    
    if (!insertPoint) {
      // Fallback: append to main content
      insertPoint = document.querySelector('main, #MainContent, [role="main"]');
    }
    
    if (!insertPoint) return;
    
    // Create loyalty teaser
    var teaserDiv = document.createElement('div');
    teaserDiv.className = 'cg-loyalty-teaser';
    teaserDiv.innerHTML = [
      '<div class="cg-loyalty-content">',
      '  <div class="cg-loyalty-badge">COMING SOON</div>',
      '  <h3 class="cg-loyalty-title">🏆 The Grind Rewards Program</h3>',
      '  <p class="cg-loyalty-text">Earn points on every purchase. Get exclusive discounts, early access to new designs, and VIP perks.</p>',
      '  <div class="cg-loyalty-perks">',
      '    <div class="cg-loyalty-perk"><span>💰</span> Earn 1 point per $1 spent</div>',
      '    <div class="cg-loyalty-perk"><span>🎁</span> 100 points = $5 reward</div>',
      '    <div class="cg-loyalty-perk"><span>👥</span> Refer friends, earn bonus points</div>',
      '  </div>',
      '  <button class="cg-loyalty-btn">Notify Me When It Launches</button>',
      '</div>'
    ].join('');
    
    // Insert after the target element
    if (insertPoint.nextSibling) {
      insertPoint.parentNode.insertBefore(teaserDiv, insertPoint.nextSibling);
    } else {
      insertPoint.parentNode.appendChild(teaserDiv);
    }
    
    // Add styles
    addLoyaltyStyles();
    
    // Handle button click (use email popup if available)
    var loyaltyBtn = teaserDiv.querySelector('.cg-loyalty-btn');
    loyaltyBtn.addEventListener('click', function() {
      // Try to trigger email popup
      var emailPopup = document.getElementById('cg-email-popup');
      if (emailPopup) {
        emailPopup.classList.add('active');
        document.body.style.overflow = 'hidden';
      } else {
        // Fallback: scroll to footer newsletter
        var footer = document.querySelector('footer, .footer, #footer');
        if (footer) {
          footer.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
    
    console.log("[CG Revenue] Loyalty teaser added");
  }
  
  function addLoyaltyStyles() {
    if (document.getElementById('cg-loyalty-styles')) return;
    
    var style = document.createElement('style');
    style.id = 'cg-loyalty-styles';
    style.textContent = [
      '.cg-loyalty-teaser{background:linear-gradient(135deg,#1e3a5f 0%,#2d4a6f 50%,#1e3a5f 100%);border-radius:16px;padding:32px;margin:40px auto;max-width:800px;text-align:center;position:relative;overflow:hidden;}',
      '.cg-loyalty-teaser::before{content:"";position:absolute;top:0;left:0;right:0;bottom:0;background:url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'0.05\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");opacity:0.5;}',
      '.cg-loyalty-content{position:relative;z-index:1;}',
      '.cg-loyalty-badge{display:inline-block;background:#f59e0b;color:#fff;font-size:11px;font-weight:700;padding:4px 12px;border-radius:20px;margin-bottom:16px;letter-spacing:1px;}',
      '.cg-loyalty-title{color:#fff;font-size:24px;font-weight:700;margin:0 0 12px;}',
      '.cg-loyalty-text{color:rgba(255,255,255,0.85);font-size:15px;margin:0 0 24px;max-width:500px;margin-left:auto;margin-right:auto;line-height:1.6;}',
      '.cg-loyalty-perks{display:flex;flex-wrap:wrap;justify-content:center;gap:16px;margin-bottom:24px;}',
      '.cg-loyalty-perk{background:rgba(255,255,255,0.1);border-radius:8px;padding:12px 16px;font-size:13px;color:#fff;display:flex;align-items:center;gap:8px;backdrop-filter:blur(4px);}',
      '.cg-loyalty-perk span{font-size:18px;}',
      '.cg-loyalty-btn{background:#fff;color:#1e3a5f;border:none;padding:14px 28px;border-radius:8px;font-size:15px;font-weight:700;cursor:pointer;transition:all 0.2s;}',
      '.cg-loyalty-btn:hover{transform:translateY(-2px);box-shadow:0 8px 20px rgba(0,0,0,0.2);}',
      '@media(max-width:600px){',
      '  .cg-loyalty-teaser{padding:24px 16px;margin:24px 16px;}',
      '  .cg-loyalty-title{font-size:20px;}',
      '  .cg-loyalty-perks{flex-direction:column;align-items:center;}',
      '  .cg-loyalty-perk{width:100%;justify-content:center;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }
  
  // ============================================================
  // Initialize All Features
  // ============================================================
  function init() {
    // Small delay to ensure DOM is ready
    setTimeout(function() {
      addBNPLMessaging();
      /* disabled: fake bulk-discount banner */ // addBundleDiscountBanner();
      addStickyATC();
      addUrgencyElements();
      // addLoyaltyTeaser(); // REMOVED: Grind Rewards teaser per user request
    }, 500);
    
    // Re-run on dynamic content changes (for SPAs)
    var observer = new MutationObserver(function(mutations) {
      var shouldRerun = mutations.some(function(m) {
        return m.addedNodes.length > 0 && m.target.querySelector && 
               (m.target.querySelector('.product-form') || m.target.querySelector('[class*="product"]'));
      });
      if (shouldRerun) {
        setTimeout(function() {
          addBNPLMessaging();
          /* disabled: fake bulk-discount banner */ // addBundleDiscountBanner();
          addUrgencyElements();
        }, 300);
      }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
    
    console.log("[CG Revenue] All features initialized");
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();
